import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  PartidosBySolicitud: [],
};
export const mutations = {
  GET_PARTIDOSBYSOLICITUD({ context }, result_partidos) {
    state.loading = false;
    if (result_partidos) {
      let partidos = [];
      Object.entries(result_partidos).forEach(([key, val]) => partidos.push(val));
      return (state.PartidosBySolicitud = partidos);
    }
  },
  SAVE_PARTIDO({ context }, partido) {
    state.newPartido = Object.assign({}, partido);
  },
};
export const actions = {
  GET_PARTIDOSBYSOLICITUD({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data.data);
          commit("SET_LOADING", false);
          commit("GET_PARTIDOSBYSOLICITUD", response.data.data.partidos_judiciales);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE_PARTIDO({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_PARTIDO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  DELETE_PARTIDO({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.delete(id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  VERIFICAR_PARTIDO_JUDICIAL_SOLICITUD({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          //commit("SAVE_ESPECIALIDAD_SOLICITUD", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
};

export const getters = {
  PartidosBySolicitud: state => state.PartidosBySolicitud,
};
